var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDateFinderHomeStream(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "36px",
    viewBox: "0 0 35 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icDateFinderHome") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-44.000000, -22.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icDateFinderHome",
    transform: "translate(44.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    transform: "translate(5.073739, 0.000000)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#FFFFFF",
    fillRule: "nonzero",
    x: 0.5,
    y: 3.2425139,
    width: 33.2477376,
    height: 30.742059,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.634217362,9.5226177 L33.6135202,9.5226177 L0.634217362,9.5226177 Z M6.97639098,1.77635684e-15 C8.02719672,1.58332696e-15 8.87904307,0.851846355 8.87904307,1.90265209 L8.87904307,4.44575971 C8.87904307,5.49656544 8.02719672,6.3484118 6.97639098,6.3484118 C5.92558525,6.3484118 5.0737389,5.49656544 5.0737389,4.44575971 L5.0737389,1.90265209 C5.0737389,0.851846355 5.92558525,1.96938672e-15 6.97639098,1.77635684e-15 Z M17.1238688,1.77635684e-15 C18.1746745,1.58332696e-15 19.0265209,0.851846355 19.0265209,1.90265209 L19.0265209,4.44575971 C19.0265209,5.49656544 18.1746745,6.3484118 17.1238688,6.3484118 C16.073063,6.3484118 15.2212167,5.49656544 15.2212167,4.44575971 L15.2212167,1.90265209 C15.2212167,0.851846355 16.073063,1.96938672e-15 17.1238688,1.77635684e-15 Z M27.2713466,1.77635684e-15 C28.3221523,1.58332696e-15 29.1739987,0.851846355 29.1739987,1.90265209 L29.1739987,4.44575971 C29.1739987,5.49656544 28.3221523,6.3484118 27.2713466,6.3484118 C26.2205408,6.3484118 25.3686945,5.49656544 25.3686945,4.44575971 L25.3686945,1.90265209 C25.3686945,0.851846355 26.2205408,1.96938672e-15 27.2713466,1.77635684e-15 Z",
    id: "Combined-Shape",
    stroke: "#FFFFFF",
    strokeLinecap: "square",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.16679,15.2554412 C22.1703846,14.2605909 20.8455519,13.7125695 19.4361791,13.7125695 C18.3609344,13.7125695 17.334495,14.0316934 16.4658731,14.624828 C15.5971121,14.0315546 14.5708117,13.7125695 13.495567,13.7125695 C12.0863333,13.7125695 10.7613615,14.2605909 9.7649561,15.2553024 C8.76827257,16.250014 8.21945701,17.5725945 8.21945701,18.9797102 C8.21945701,20.3865483 8.76827257,21.7094064 9.7649561,22.7042568 L15.7055682,28.6343534 C15.915528,28.8439563 16.1908396,28.9487578 16.4660121,28.9487578 C16.7411846,28.9487578 17.0164962,28.8439563 17.2265951,28.6342146 L23.16679,22.7039791 C25.2232841,20.6501482 25.223145,17.3087169 23.16679,15.2554412 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDateFinderHomeStream);
export default __webpack_public_path__ + "static/media/icDateFinderHomeStream.711848de895c86e5abf377825afd9b91.svg";
export { ForwardRef as ReactComponent };